var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDirectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.87,
    height: 10.773,
    viewBox: "0 0 7.87 10.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.746.128A.356.356,0,0,0,6.2.585.36.36,0,0,0,6.244.63L8.806,3.2H.339a.358.358,0,0,0,0,.714H8.806L6.24,6.471a.364.364,0,0,0,0,.5.354.354,0,0,0,.5,0h0L9.916,3.8a.348.348,0,0,0,.009-.493L9.916,3.3Z",
    transform: "translate(0.418 10.398) rotate(-90)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDirectionIcon);
export default __webpack_public_path__ + "static/media/sort_direction_icon.7aba84087a025da63190f43c8021f729.svg";
export { ForwardRef as ReactComponent };